import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { ElevationService } from './elevation.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private elevationService: ElevationService) {}

  getPreviewUrl(file): Observable<any> {
    return this.elevationService.getData(`/file/previewUrl/${file.uuid}`);
  }

  downloadFile(file): Observable<any> {
    return this.elevationService.getData(
      `/file/download/${file.uuid}`,
      {},
      { headers: {}, responseType: 'blob' },
    );
  }

  getFile(uuid): Observable<any> {
    return this.elevationService.getData(`/file/${uuid}`);
  }

  ensurePath(path: string): Observable<any> {
    return this.elevationService.postData(`/file/ensurePath`, { path });
  }

  uploadFiles(files: File | File[], info): Observable<any> {
    const formData = new FormData();

    const fileArray = Array.isArray(files) ? files : [files];

    for (const file of fileArray) {
      formData.append('files', file);
    }

    if (info?.parent) {
      formData.append('parent', info.parent);
    }
    if (info?.path) {
      formData.append('path', info.path);
    }
    if (info?.file_data) {
      formData.append('file_data', JSON.stringify(info.file_data));
    }

    return this.elevationService.postData(`/file`, formData);
  }

  createFolder(name, parent): Observable<any> {
    return this.elevationService.postData(`/file/folder`, { name, parent });
  }

  scanFileSystem(): Observable<any> {
    return this.elevationService.postData(
      `/file/scan`,
      {},
      {},
      { headers: { timeout: '600000' } },
    );
  }

  updateFile(file): Observable<any> {
    return this.elevationService.patch(`/file/${file.uuid}`, {
      name: file.name,
      parent: file.parent,
    });
  }

  deleteFile(file): Observable<any> {
    return this.elevationService.postData(`/file/delete/${file.uuid}`, {});
  }

  listFiles(parent?: string, hiddenFiles?: string[]): Observable<any> {
    return this.elevationService.getData(`/file`, {
      parent,
      hidden_files: hiddenFiles,
    });
  }

  searchFiles(query: string): Observable<any> {
    return this.elevationService.getData(`/file/search/${query}`);
  }

  getFullPathObject(file_uuid): Observable<any> {
    return this.elevationService.getData(`/file/fullPathObject/${file_uuid}`);
  }

  downloadCsvFileFromResponse(response, fileName?: string): void {
    {
      const blob = new Blob([response.body], { type: 'text/csv' });
      const contentDisposition = response.headers.get('Content-Disposition');
      const matches = /filename="(.+)"/.exec(contentDisposition || '');
      const filename = fileName ?? matches?.[1] ?? 'data.csv';
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(link.href);
      link.remove();
    }
  }

  zipFolder(folder_path?, folder_uuid?, destination?): Observable<any> {
    return this.elevationService.postData(`/file/zip`, {
      uuid: folder_uuid,
      path: folder_path,
      destination,
    });
  }

  downloadFolder(folder_uuid?): Observable<any> {
    return this.elevationService.getData(
      `/file/downloadFolder/${folder_uuid}`,
      {},
      { headers: { timeout: '600000' }, responseType: 'blob' },
    );
  }
}
